import { toast, Slide } from 'react-toastify';

toast.configure({
  position: "bottom-left",
  hideProgressBar: true,
  transition: Slide,
});